"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Typography_1 = require("@material-ui/core/Typography");
exports.default = (function () { return (React.createElement(Typography_1.default, { variant: "h3" }, "Loading....")); });
